(function () {
    var InsinuationBanner = {
        $findMyInstButton: $('.no-institution-link'),

        init: function () {
            InsinuationBanner.controller();
        },
        controller: function () {
            var pbContext;
            var redirectUri;
            var newHref;

            InsinuationBanner.$findMyInstButton.on('click', function () {
                pbContext = InsinuationBanner.getPbContext();
                if (pbContext.indexOf('List of Issues') !== -1) {
                    redirectUri = window.location.pathname;
                    newHref = '/action/ssostart?redirectUri=' + encodeURIComponent(redirectUri);
                    InsinuationBanner.$findMyInstButton.attr('href', newHref);
                    window.location = window.location.origin + newHref;
                }
            });
        },

        getPbContext: function () {
            var pbContext = $('[name="pbContext"]').attr('content');
            return pbContext ? pbContext : '';
        },
    };

    UX.InsinuationBanner = InsinuationBanner;
})();
